

export default function attendance_checkCanEdit(date: Moment) {

    const isManager = gd.ac.check.company.isManager(gd.companyId);

    if(isManager){
        return true
    }
    else{
        return moment().diff(date, 'days') <= gd.modules.clockInOut.editDuration
    }

}
